import React from 'react';

/**
 * One-line caption for a report: what it shows, and over which period.
 *
 * Each report passes its period in whatever form it already holds — a week
 * start, a month, an explicit range — and this works out the wording, so the
 * ten report pages don't each carry their own date-formatting logic.
 *
 * Pass exactly one of: weekStart, month, from+to, or period.
 */

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'];

function ddmmyyyy(iso) {
  if (!iso || iso.length < 10) return iso || '';
  const [y, m, d] = iso.slice(0, 10).split('-');
  return `${d}-${m}-${y}`;
}

function addDays(iso, n) {
  // Midday avoids the DST edge where adding a day can land on the same date.
  const d = new Date(`${iso}T12:00:00`);
  d.setDate(d.getDate() + n);
  return [d.getFullYear(),
          String(d.getMonth() + 1).padStart(2, '0'),
          String(d.getDate()).padStart(2, '0')].join('-');
}

export default function ReportNote({ what, from, to, weekStart, month, period, note }) {
  let range = period || '';
  if (!range && weekStart) {
    range = `${ddmmyyyy(weekStart)} → ${ddmmyyyy(addDays(weekStart, 6))}`;
  }
  if (!range && month && month.length >= 7) {
    const [y, m] = month.split('-');
    range = `${MONTHS[Number(m) - 1] || month} ${y}`;
  }
  if (!range && from && to) {
    range = `${ddmmyyyy(from)} → ${ddmmyyyy(to)}`;
  }

  return (
    <div className="report-note">
      <span>{what}</span>
      {range && <span className="report-note-period">{range}</span>}
      {note && <span className="report-note-extra">{note}</span>}
    </div>
  );
}
